$('a[href^="#"]').on('click', function () {
  const speed = 500;
  const easing = 'swing';
  const href = $(this).attr('href');
  const target = $(href == '#' || href == '' ? 'html' : href);
  const spt = parseInt($('html').css('scrollPaddingTop')) || 0;
  const smt = parseInt($(target).css('scrollMarginTop')) || 0;
  // スクロール先
  const position = target.offset().top - (spt + smt);
  $('html, body').animate({ scrollTop: position }, speed, easing);
  return false;
});

// ナビ固定: .header-nav が .header の下に差し掛かった段階で position: fixed（PCのみ）
$(function () {
  var $header = $('.header');
  var $nav = $('.header-nav.js-nav-content');
  if (!$header.length || !$nav.length) return;

  var cachedThreshold = null; // fixed 時に remove 判定に使うしきい値（非固定時の offset で算出）

  function updateNavFixed() {
    if (window.innerWidth <= 768) return;
    // .header の margin-top を含めたビューポート上での下端（fixed 時は常に同じ）
    var headerBottom = $header[0].getBoundingClientRect().bottom;
    var scrollTop = $(window).scrollTop();

    if ($nav.hasClass('is-navFixed')) {
      // 固定中は offset() がずれるので、キャッシュしたしきい値で remove 判定
      if (cachedThreshold !== null && scrollTop < cachedThreshold) {
        $nav.removeClass('is-navFixed')[0].style.removeProperty('--header-nav-fixed-top');
        cachedThreshold = null;
      }
    } else {
      // 非固定時はナビの document 上の位置でしきい値を算出（header 下端 = margin-top 込み）
      var navOffsetTop = $nav.offset().top;
      var scrollThreshold = navOffsetTop - headerBottom;
      if (scrollTop >= scrollThreshold) {
        cachedThreshold = scrollThreshold;
        $nav.addClass('is-navFixed')[0].style.setProperty('--header-nav-fixed-top', (headerBottom + 5) + 'px');
      }
    }
  }

  $(window).on('scroll.navFixed resize.navFixed', function () {
    updateNavFixed();
    updateSubLinkDirection();
  });
  updateNavFixed();
  updateSubLinkDirection();
});

// ヘッダーテキスト: MV以下にスクロールしたら文字色を黒に（PC／SP）
$(function () {
  var $header = $('.header');
  if (!$header.length) return;

  function updateHeaderTextColor() {
    var $mv = $('.topMv, .lowerMv').first();
    if (!$mv.length) {
      $header.addClass('is-pastMv');
      return;
    }
    var mvBottom = $mv[0].getBoundingClientRect().bottom;
    if (mvBottom <= 0) {
      $header.addClass('is-pastMv');
    } else {
      $header.removeClass('is-pastMv');
    }
  }

  $(window).on('scroll.headerTextColor resize.headerTextColor', updateHeaderTextColor);
  updateHeaderTextColor();
});

// subLink の表示方向: header-navList が画面半分より上に入ったら .is-subLink-down を付与
// 下方向のスタイルは .is-navFixed のときだけ適用（SCSS で .is-subLink-down.is-navFixed のときのみ bottom 指定）
function updateSubLinkDirection() {
  if (window.innerWidth <= 768) return;
  var $nav = $('.header-nav.js-nav-content');
  if (!$nav.length) return;
  $('.subLink').each(function () {
    this.style.removeProperty('display');
  });
  var $navList = $('.header-navList');
  var listTop = $navList.length ? $navList[0].getBoundingClientRect().top : 0;
  var viewportHalf = window.innerHeight / 2;
  if (listTop < viewportHalf) {
    $nav.addClass('is-subLink-down');
  } else {
    $nav.removeClass('is-subLink-down');
  }
}

// 外部リンクのアニメーション
var urlHash = location.hash;
var headerHeight = $('.header').outerHeight(true);
if (urlHash) {
  $('body,html').stop().scrollTop(0);
  setTimeout(function() {
    var target = $(urlHash);
    var position = target.offset().top - headerHeight;
    $('body,html').stop().animate({
      scrollTop: position
    }, 500);
  }, 100);
}

// SP nav
$(document).ready(function () {

  // ハンバーガー開閉
  $('.js-nav-bt').on('click', function (e) {
    e.stopPropagation();
    $('.js-nav-content, .js-nav-logo, .js-nav-bt')
      .toggleClass('is-navOn');
  });

  // SPのときだけ、リンクを押したら閉じる
  $('.js-nav-bt.is-navOn, .js-nav-logo.is-navOn, .js-nav-link')
  .not('.is-subLink .js-nav-link')
  .on('click', function (e) {

    if (window.innerWidth <= 768) {
      $(".js-nav-content, .js-nav-logo, .js-nav-bt")
        .removeClass('is-navOn');
    }
});
});

if (window.matchMedia("(max-width: 768px)").matches) {
  $('.is-subLink > .js-nav-link').on('click', function(e){

  e.preventDefault();
  e.stopPropagation();

  const $parent = $(this).closest('.is-subLink');
  const $sub = $parent.find('.subLink');
  const $plus = $parent.find('.js-sp-navDown');

  $('.subLink').not($sub).slideUp();
  $('.js-sp-navDown').not($plus).removeClass('is-on');

  $sub.stop(true, true).slideToggle();
  $plus.toggleClass('is-on');

});

  $(function () {
    $(window).on("scroll", function () {
      const sliderHeight = $(".topMv").height();
      if (sliderHeight - 30 < $(this).scrollTop()) {
        $(".js-header-sp").addClass("is-headerOn");
      } else {
        $(".js-header-sp").removeClass("is-headerOn");
      }
    });
  });

  $(function () {
    $(window).on("scroll", function () {
      scrollHeight = $(document).height();
      scrollPosition = $(window).height() + $(window).scrollTop();
      footHeight = $(".js-footer-sp").innerHeight();
      if (scrollHeight - scrollPosition <= footHeight) {
        $(".js-cv-sp").addClass("is-none");
      } else {
        $(".js-cv-sp").removeClass("is-none");
      }
    });
  });

  jQuery(function($) {
    $('.js-sp-navDown').on('click', function (e) {

      e.preventDefault();
      e.stopPropagation();

      const $sub = $(this).next();

      $('.subLink').not($sub).slideUp();
      $('.js-sp-navDown').not(this).removeClass('is-on');

      $sub.stop(true, true).slideToggle();
      $(this).toggleClass('is-on');
    });
  });


}

jQuery(function($) {
  //tab
  $(function () {
    $('.js-tab .js-tabItem').click(function () {
      var index = $('.js-tab .js-tabItem').index(this);
      $('.js-tab .js-tabItem').removeClass('is-on');
      $(this).addClass('is-on');
      $('.js-tabArea .js-tabcCntents').removeClass('is-on').eq(index).addClass('is-on');
    });
  });
});

$('.sec06-card__toggle').on('click', function(){
  $(this).parent('.sec06-card__body').toggleClass('is-open');
});

// 下層ページのテーブルを .table-scroll-wrapper で自動ラップ（SPでも横並び＋横スクロール）
$(function () {
  $('.local table').each(function () {
    if ($(this).closest('.contact-form').length) return; // CF7フォーム内は対象外
    if ($(this).closest('.table-scroll-wrapper').length) return; // 既にラップ済み
    $(this).wrap('<div class="table-scroll-wrapper"></div>');
  });
});